
export function getRequestKey (req) {
    return req.method+':'+req.url
}

export function getRequestByKey (requests, requestKey) {
    return requests.find( (req) => {
        return getRequestKey(req) === requestKey
    })
}

export function getRequestIndexByKey (requests, requestKey) {
    return requests.findIndex( (req) => {
        return getRequestKey(req.request) === requestKey
    })
}